import { Fn, vec2 } from "three/tsl"

export const scaleUV = Fn(([uv, scale]: [any, any]) => {
  return uv.toVar().sub(vec2(0.5)).mul(scale).add(vec2(0.5))
})
